// İSG uzmanı portalı — Kiosk cihaz yönetimi (api-contract §5.9) TanStack Query
// anahtarları. Liste anahtarı parametreleri içerir (sayfa/arama değişince yeniden
// çeker); invalidasyon önek (prefix) ile yapılır: `['kiosk','devices']` tüm cihaz
// listesi sorgularını kapsar (kayıt/iptal sonrası tazeleme).

import type { KioskListParams } from '@isgportal/shared';

export const kioskKeys = {
  /** Cihaz listesi (parametreli veya önek). */
  devices: (params?: KioskListParams) =>
    params ? (['kiosk', 'devices', params] as const) : (['kiosk', 'devices'] as const),
  /** Erişim sondası (menü/sekme görünürlüğü) — liste ucunu pageSize:1 ile yoklar. */
  access: () => ['kiosk', 'access'] as const,
} as const;
